import { ChevronRight } from 'lucide-react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { isTaskReadinessComplete } from '../../helpers';
import HuddleTaskRow from '../HuddleTaskRow';
import styles from './HuddleTasksSection.module.scss';

const HuddleTasksSection = ({
  tasks = [],
  markingTaskId,
  assigningTaskId,
  onMarkComplete,
  onAssignToMe,
  onOpenTask,
}) => {
  const [expanded, setExpanded] = useState(false);
  const doneCount = tasks.filter((task) => isTaskReadinessComplete(task)).length;
  const meta =
    tasks.length === 0
      ? 'None'
      : doneCount > 0
        ? `${doneCount}/${tasks.length} done`
        : `${tasks.length} open`;

  return (
    <>
      <button
        type="button"
        className={styles.headerRow}
        aria-expanded={expanded}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <span className={styles.headerTitle}>
          <ChevronRight
            size={18}
            className={`${styles.chevron} ${expanded ? styles.chevronOpen : ''}`}
            aria-hidden="true"
          />
          Outstanding tasks
        </span>
        <span className={styles.headerMeta}>{meta}</span>
      </button>

      {expanded &&
        (tasks.length === 0 ? (
          <div className={styles.emptyRow}>Nothing outstanding for this visit.</div>
        ) : (
          tasks.map((task) => (
            <HuddleTaskRow
              key={task.id}
              task={task}
              isMarking={markingTaskId === task.id}
              isAssigning={assigningTaskId?.has?.(task.id)}
              onMarkComplete={onMarkComplete}
              onAssignToMe={onAssignToMe}
              onOpen={onOpenTask}
            />
          ))
        ))}
    </>
  );
};

HuddleTasksSection.propTypes = {
  tasks: PropTypes.array,
  markingTaskId: PropTypes.string,
  assigningTaskId: PropTypes.object,
  onMarkComplete: PropTypes.func.isRequired,
  onAssignToMe: PropTypes.func.isRequired,
  onOpenTask: PropTypes.func.isRequired,
};

export default HuddleTasksSection;
